import React, { useState } from 'react';
import useBrandContext from 'contexts/brand.context';
import EditBrandMetadata from './edit-brand-metadata';
import PreviewBrandMetadata from './preview-brand-metadata';
import PageHeaderText from 'components/base/page-header-text';
import { ROUTE_KEYS, ROUTE_PREFIX } from 'utils/constants';
import { Breadcrumbs } from '@cokitchen/cokitchen-components';

const BrandDetailsMetadata = () => {
  const { activeBrand } = useBrandContext();
  const [editing, setEditing] = useState(false);

  const breadcrumbs = [
    { name: 'Overview', path: `${ROUTE_PREFIX.FOOD}/${ROUTE_KEYS.OVERVIEW}` },
    {
      name: `${activeBrand?.name}`,
      path: ''
    }
  ];

  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <PageHeaderText
        title={activeBrand?.name ?? 'brand'}
        description={`Update ${activeBrand?.name ?? 'brand'} details here`}>
        {!editing && (
          <button
            className='border border-[#E7E8E9] shadow text-[#5C5F64] w-[86px] h-[40px] py-2 rounded-[8px]'
            onClick={() => {
              setEditing(true);
            }}>
            Edit
          </button>
        )}
      </PageHeaderText>

      {/* <div className='w-full py-[18px] px-[20px] bg-[#F8F7F7] border border-[#EEECEC] rounded-lg mb-12'>
        <div className='flex gap-[8px] items-center mb-2'>
          <MetadataIcon className='w-[17.33px] h-[17.33px]' />
          <p className='text-sm font-medium text-[#1D0105]'>How do Metadatas work</p>
        </div>
        <p className='text-sm text-[#1D0105]'>
          Ante dolor feugiat sed ut et. Nunc magna sit praesent lectus proin ultrices. Viverra morbi
          libero odio a at et sed pharetra nisi.
        </p>
      </div> */}
      {editing ? <EditBrandMetadata /> : <PreviewBrandMetadata />}
    </div>
  );
};

export default BrandDetailsMetadata;
